import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#590738',
      light: '#BD0F77',
      dark: '#13020C',
      contrastText: 'white'
    },
    secondary: {
      main: '#F7C9C6',
      light: '#EDE8D8',
      dark: '#ED8C8C',
      contrastText: 'black'
    },
    error: {
      main: '#ED8C8C',
    }
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        standardInfo: {
          backgroundColor: '#f7c9c6',
          color: 'black',
          '& .MuiAlert-icon': {
            color: 'black',
          },
        },
      },
    },
  },
});

export default theme;
